import PredictionModeSwitch from "./PredictionModeSwitch";
export default PredictionModeSwitch;